<template>
  <div class="widget">
    <div class="widget-title">{{ title('Summary Daily') }}</div>
    <div class="widget-content">

      <div
        class="widget-item monthly"
        v-if="settings.value.show_goal"
      >
          Daily Goal :
          <span class="value goal">
            {{ getData.goal | numFormat(currency) }}
          </span>
          <span class="word-sales" v-if="!currency">Sales</span>
      </div>

      <div
        class="widget-item current"
        v-if="settings.value.show_current_total_value"
      >
        Current Total :
        <span class="value total">
          {{ getData.total | numFormat(currency) }}
        </span>
        <span class="word-sales" v-if="!currency">Sales</span>
      </div>

      <div
        class="widget-item per-day"
        v-if="settings.value.show_needed_per_hour"
      >
        Needed Per Hour :
        <span class="value needed">
          {{ getData.need_per_hour | numFormat(currency) }}
        </span>
        <span class="word-sales" v-if="!currency">Sales</span>
      </div>

    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import widgetHelper from "@/mixins/widgetHelper";

export default {
  mixins: [widgetHelper],
  computed: {
    ...mapGetters(["streams"]),
    getData() {
      let elems = this.getElemsForCalc;
      if (!elems?.length) { return {} }

      let goal = 0;
      let total = 0;

      let working = 0;

      for (const elem of elems) {
        goal += elem[this.useByPaymentCapacity('daily')]?.goal || 0;

        if (this.target_type === 'Amount') {
          total += elem[this.useByPaymentCapacity('daily')]?.[this.useNetAmount()] || 0;
        } else {
          total += (elem[this.useByPaymentCapacity('daily')]?.[this.useNetCount] || 0);
        }

        if (elem[this.useByPaymentCapacity('monthly')]?.days?.working > working) {
          working = elem[this.useByPaymentCapacity('monthly')]?.days?.working || 0;
        }
      }

      let need_per_hour = (goal - total) / 8;
      if (need_per_hour < 0) { need_per_hour = (goal / working) / 8; }

      return { goal, total, need_per_hour };
    },
  },
};
</script>
